import React from 'react'
import {App} from '../components/App'
import {IRemotePlayer} from '../types/IRemotePlayer'

interface Props {
    metrikaId: number
    player: IRemotePlayer
    onComplete: Function
    onEndBattle: Function
    onCloseConfirm: Function
    lang: string
}

export class AppWithMetrika extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props)
        this.initCounter()
    }

    render(): JSX.Element {
        const {metrikaId} = this.props

        return (
            <App
                {...this.props}
                onVisitParams={(params: object | string) => {
                    if (typeof params === 'string') {
                        params = {[params]: 1}
                    }
                    try {
                        //@ts-ignore
                        let counter = window['yaCounter' + metrikaId]
                        counter.params(params)
                        console.log('visit params:', params)
                    } catch (err) {
                        console.error('error save visit params:', err.message)
                    }
                }}
            />
        )
    }

    private initCounter(): void {
        const {metrikaId} = this.props
        ;(function(d, w, c) {
            // @ts-ignore
            ;(w[c] = w[c] || []).push(function() {
                try {
                    // @ts-ignore
                    w['yaCounter' + metrikaId] = new Ya.Metrika({
                        id: metrikaId,
                        clickmap: true,
                        trackLinks: true,
                        accurateTrackBounce: true,
                    })
                } catch (e) {}
            })

            let n = d.getElementsByTagName('script')[0],
                s = d.createElement('script'),
                f = function() {
                    // @ts-ignore
                    n.parentNode.insertBefore(s, n)
                }
            s.type = 'text/javascript'
            s.async = true
            s.src = 'https://mc.yandex.ru/metrika/watch.js'

            // @ts-ignore
            if (w.opera === '[object Opera]') {
                d.addEventListener('DOMContentLoaded', f, false)
            } else {
                f()
            }
        })(document, window, 'yandex_metrika_callbacks')
    }
}
